import '../styles/components/AboutUs.css';
import { m } from 'framer-motion';
import { fadeUp, viewport } from '../motion/variants';

const products = [
  { name: 'Bricks', imageSrc: '/img/bricks.jpg' },
  { name: 'Pebbles', imageSrc: '/img/abl1.jpeg' },
  { name: 'Cement', imageSrc: '/img/cemebt.jpg' },
  { name: 'Sand', imageSrc: '/img/abl3.jpeg' },
  { name: 'Wood', imageSrc: '/img/wood.webp' },
  { name: 'Tiles', imageSrc: '/img/tiles.jpeg' },
  { name: 'Concrete', imageSrc: '/img/concrete.jpeg' },
  { name: 'Stones', imageSrc: '/img/stones.jpeg' },
  { name: 'Glass', imageSrc: '/img/glass.webp' },
];

const aboutSection = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.14, delayChildren: 0.04 },
  },
};

function AboutUs() {
  const trackItems = [...products, ...products];

  return (
    <m.section
      className="about"
      id="about"
      initial="hidden"
      whileInView="visible"
      viewport={viewport}
      variants={aboutSection}
    >
      <div className="about-inner">
        <m.div className="about-split" variants={fadeUp}>
          <div className="about-split-copy">
            <h2>About Us</h2>
            <p className="about-split-lead">
              ABL Construction Limited supplies trusted construction materials and logistics support
              to help projects move faster and build stronger. We focus on consistent quality,
              competitive pricing, and reliable delivery.
              From residential builds to large infrastructure jobs, we source and deliver the
              materials your crew needs — bricks, cement, sand, aggregates, timber, and more —
              with the consistency site managers depend on.
            </p>
            <p>
              Our team coordinates transport and on-time drop-offs across Tanzania so you spend less
              time chasing supplies and more time building.
            </p>
          </div>
          <div className="about-split-media">
            <img
              src="/img/abl6.jpeg"
              alt="ABL Construction truck delivering sand to a project site"
              loading="lazy"
            />
          </div>
        </m.div>

        <m.div
          className="about-marquee"
          aria-label="Construction products scrolling list"
          variants={fadeUp}
        >
          <div className="about-track" aria-hidden="true">
            {trackItems.map((item, idx) => (
              <article className="about-card" key={`${item.name}-${idx}`}>
                <div className="about-card-media">
                  <img src={item.imageSrc} alt="" loading="lazy" />
                </div>
                <div className="about-card-title">{item.name}</div>
              </article>
            ))}
          </div>
        </m.div>
      </div>
    </m.section>
  );
}

export default AboutUs;
